import React from 'react';
import { useSelector } from 'react-redux';

import { TerminalDepositModesEnum } from '@app/dev/constants/enums/terminalDepositModes';

import CashoutPrintTicket from './printTicket';
import CashoutOkto from './okto';

import './style.scss';

const Cashout = ({ clearStateBeforeCashout }) => {
  const { depositMode } = useSelector((state) => state.terminal);

  const isOktoPay = depositMode === TerminalDepositModesEnum.Octo;

  return isOktoPay
    ? <CashoutOkto clearStateBeforeCashout={clearStateBeforeCashout} />
    : <CashoutPrintTicket clearStateBeforeCashout={clearStateBeforeCashout} />;
};

export default Cashout;
